
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { AttendanceType } from '@/models/attendanceModel';
import { useTranslation } from 'react-i18next';

interface MonthlySummaryProps {
  totalHours: number;
  byType: Record<AttendanceType, number>;
}

export const MonthlySummary = ({ totalHours, byType }: MonthlySummaryProps) => {
  const { t } = useTranslation();
  
  // Calculate percentages for each type
  const getPercentage = (hours: number) => {
    if (totalHours === 0) return 0;
    return (hours / totalHours) * 100;
  };

  const typeLabels: Record<AttendanceType, string> = {
    work: t('regularWork'),
    overtime: t('overtime'),
    holiday: t('holiday'),
    sick: t('sickLeave'),
    other: t('otherAbsence')
  };

  const typeColors: Record<AttendanceType, string> = {
    work: 'bg-green-500',
    overtime: 'bg-amber-500',
    holiday: 'bg-blue-500',
    sick: 'bg-red-500',
    other: 'bg-gray-500'
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{t('monthlySummary')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold mb-4">
          {totalHours.toFixed(1)} {t('hours')}
        </div>
        
        <div className="space-y-4">
          {Object.entries(byType).map(([type, hours]) => {
            const typedType = type as AttendanceType;
            const percentage = getPercentage(hours);
            
            return hours > 0 ? (
              <div key={type} className="space-y-1">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">{typeLabels[typedType]}</span>
                  <span className="text-sm font-medium">{hours.toFixed(1)}h</span>
                </div>
                <Progress value={percentage} className={typeColors[typedType]} />
              </div>
            ) : null;
          })}
        </div>
      </CardContent>
    </Card>
  );
};
